import type { Page } from '../../types';

const recruitmentFunctions: Page[] = [
  {
    pageType: 'question',
    title: 'Recruitment function',
    name: 'recruitment-function-page',
    hidePageTitle: true,
    description: 'Question 11',

    questions: [
      {
        questionType: 'radio',
        title:
          'Do you retain recruitment documentation for two years after the completion of a campaign (whether successful or unsuccessful)?',
        name: 'recruitment-retain-doc',
        options: ['Yes', 'No'],
        rules: {
          required: true,
        },
      },
      {
        questionType: 'radio',
        title: 'Do you consistently capture diversity statistics following each campaign?',
        name: 'recruitment-diversity-stats',
        options: ['Always', 'Never', 'Sometimes'],
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textarea',
        title: 'Please provide details of any analysis that is undertaken using this data',
        name: 'analysis-under-taken',
        // detailsContent: 'Key contact 2 email address',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'radio',
        title: 'Do you have a diversity strategy in place?',
        name: 'recruitment-diversity-strategy',
        options: ['Yes', 'No'],
        rules: {
          required: true,
        },
      },
      {
        questionType: 'radio',
        title: 'Is diversity considered during the planning stages of each recruitment campaign?',
        name: 'recruitment-diversity-considered',
        options: ['Always', 'Never', 'Sometimes'],
        rules: {
          required: true,
        },
      },
      {
        questionType: 'checkbox',
        title:
          'What is the source of your diversity data for fair and open recruits for this return?',
        name: 'recruitment-source-diversity',
        options: [
          'Recruitment platform/Applicant Tracking System (such as WC or Oleeo)',
          'HR Management System (such as SOP or iTrent)',
          {
            option: 'Other',
            questions: [
              {
                questionType: 'textInput',
                title: 'Please Specify',
                name: 'recruitment-source-diversity-other',
                rules: {
                  required: true,
                },
              },
            ],
          },
        ],
        rules: { required: true },
      },
    ],
  },
];
export default recruitmentFunctions;
